import React from "react";
import useInfiniteSearch from "hooks/useInfiniteSearch";
import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";
import { DEFAULT_FORMS_PAGE_SIZE } from "features/CourseAnalytics/modules/ContentResponses/modules/FormsV2/modules/DesktopForms/utils/DesktopView.utils";

const DYNAMIC_LINKS_API = "/payments/exly/dynamiclinks/all";

export const useFetchCustomCodeComboPage = ({
  paymentLinkType = 4,
  initialData = {},
} = {}) => {
  const {
    data,
    loading,
    setLoading,
    setError,
    setHasMore,
    pageNumber,
    setData,
    lastElementRef,
  } = useInfiniteSearch();

  const { combos_pages_mapping: combosPagesMapping } = initialData;

  const {
    data: queryData,
    isFetching,
    isError,
  } = useCustomQuery({
    url: DYNAMIC_LINKS_API,
    queryKey: [DYNAMIC_LINKS_API, { pageNumber, paymentLinkType }],
    params: {
      page: pageNumber,
      page_size: DEFAULT_FORMS_PAGE_SIZE,
      payment_link_type: paymentLinkType,
    },
    cacheTime: 0,
    enabled: true,
  });

  React.useEffect(() => {
    if (isFetching) setLoading(true);
    if (isError) setError(true);

    if (queryData) {
      const { links = [], total_pages = 1 } = queryData;
      setHasMore(total_pages > pageNumber);

      const formattedLinks = links.map((item) => ({
        ...item,
        description: item.listing_title,
        label: item?.title,
        value: item.dynamic_link_id,
      }));

      // Selected combo mappings
      const selectedFormattedLinks = combosPagesMapping.map((data) => ({
        label: data?.title,
        value: data?.uuid,
        dynamic_link_id: data?.uuid,
        title: data?.title,
        link_price: data?.price,
        currency: data?.currency,
        pop_name: (data?.listings || []).map((lst) => lst?.title).join(", "),
      }));

      if (pageNumber === 1) {
        // Only Appending Selected Data on load pre selected
        const mergedUnique = Array.from(
          new Map(
            [...selectedFormattedLinks, ...formattedLinks].map((item) => [
              item.value,
              item,
            ])
          ).values()
        );
        setData(mergedUnique);
      } else {
        setData((prev) => {
          const merged = [...prev, ...formattedLinks];
          return Array.from(
            new Map(merged.map((item) => [item.value, item])).values()
          );
        });
      }
    }

    if (!isFetching) setLoading(false);
  }, [
    queryData,
    isFetching,
    isError,
    setLoading,
    setError,
    setHasMore,
    setData,
    pageNumber,
    combosPagesMapping,
  ]);

  return {
    data,
    loading,
    lastElementRef,
  };
};
